import React from "react";
import "../../styles/banner.css";

const Banner = ({ backgroundImage, title, description, tabs, activeTab, onTabChange }) => {
  return (
    <div className="page-banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="banner-content">
        <h1>{title}</h1>
        {Array.isArray(description) ? description.map((line, index) => <p key={index}>{line}</p>) : <p>{description}</p>}
      </div>
      <div className="tab-container">
        <div className="tab-wrapper">
          {tabs.map((tab) => (
            <div key={tab.id} className={`tab ${activeTab === tab.id ? "active" : ""}`} onClick={() => onTabChange(tab.id)}>
              {tab.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;
